/** @jsxImportSource @emotion/react */
import { withMyTheme } from "../../theme/theme"
import { alpha, css, Typography } from "@mui/material"
import { mobileCss } from "../../util/isMobile"
import { MyButton } from "../../components/button/MyButton"
import { Celebration, EmojiEmotions, FlashOn } from "@mui/icons-material"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"

const QuestionnaireContainerStyle = withMyTheme((theme) => css`
    background: linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%);
    border-radius: 16px;
    padding: 1.5rem;
    margin: 2rem auto;
    position: relative;
    z-index: 1;
    box-shadow: 0 8px 20px ${alpha(theme.palette.primary.main, 0.3)};
    max-width: 80%;
    
    ${mobileCss(`
        max-width: 100%;
    `)}
`)

const QuestionnaireTitleStyle = withMyTheme((theme) => css`
    color: ${theme.palette.primary.main};
    font-size: 1.8rem;
    font-weight: 700;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    
    svg {
        margin-right: 0.5rem;
        font-size: 1.8rem;
    }
`)

const QuestionnaireTextStyle = withMyTheme((theme) => css`
    color: white;
    font-size: 1.2rem;
    margin-bottom: 1.5rem;
    line-height: 1.5;
    text-align: center;
`)

const QuestionnaireButtonStyle = withMyTheme((theme) => css`
    display: flex;
    justify-content: center;
`)

interface QuestionnaireCardProps {
    className?: string;
}

export const QuestionnaireCard = ({ className }: QuestionnaireCardProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleQuestionnaireClick = () => {
        navigate('/questionnaire');
    };

    return <>
        <Typography css={QuestionnaireTitleStyle}>
            <FlashOn sx={{ color: ' #FFC785' }}/>
            {t('contact.questionnaire.headerTitle')}
        </Typography>
        <div css={QuestionnaireContainerStyle} className={className}>
            <Typography
                css={QuestionnaireTextStyle}
                dangerouslySetInnerHTML={{
                    __html: t('contact.questionnaire.description')
                }}
            />
            <div css={QuestionnaireButtonStyle}>
                <MyButton
                    text={t('contact.questionnaire.button')}
                    variant="white"
                    onClick={handleQuestionnaireClick}
                />
            </div>
        </div>
    </>
};
